import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./registrationManagementIdHelper.component.html')
})
export class RegistrationManagementIdHelperDialog {

    constructor(@Inject(MatDialogRef<RegistrationManagementIdHelperDialog>) public dialogRef: MatDialogRef<RegistrationManagementIdHelperDialog>) {}

    closeThisDialog(value: any){
        this.dialogRef.close(value)
    }
}
